const FormRow = ({ children }) => {
  return <div className="row py-2">{children}</div>;
};

export default FormRow;
